"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MAX_PAGES_RENDERED = 5;
const RenderPagesByRouting = ({ routeStack, rendererPage }) => (react_1.default.createElement(react_1.default.Fragment, { key: "RenderPagesByRouting" }, routeStack === null || routeStack === void 0 ? void 0 : routeStack.map((route, routeIndex) => {
    const revertIndex = routeStack.length - routeIndex;
    if (revertIndex > MAX_PAGES_RENDERED) {
        return null;
    }
    return rendererPage(route);
})));
exports.default = RenderPagesByRouting;
